import { useFormik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    location: '',
    interest: 'Rentals',
    optIn: false
};

// Custom validation for Location based on Topic
const validationSchema = Yup.object().shape({
    firstName: Yup.string()
        .required('Please enter your First Name.')
        .min(1, 'Please enter your First Name.'),
    lastName: Yup.string()
        .required('Please enter your Last Name.')
        .min(1, 'Please enter your Last Name.'),
    email: Yup.string()
        .required('Please enter your Email Address.')
        .email('Please enter a valid Email Address.'),
    location: Yup.string().required('Please enter your Email Address.'),
    optIn: Yup.boolean()
        .oneOf([true], 'Required')
        .required('Required 2')
});

const locations = [
    { text: 'Location*', value: '' },
    { text: 'Abbotsford Fraserway', value: 'Abbotsford Fraserway' },
    { text: 'Airdrie', value: 'Airdrie' },
    { text: 'Bedford', value: 'Bedford' },
    { text: 'Cookstown', value: 'Cookstown' },
    { text: 'Edmonton', value: 'Edmonton' },
    { text: 'Kamloops', value: 'Kamloops' },
    { text: 'Kelowna', value: 'Kelowna' },
    { text: 'Lacombe', value: 'Lacombe' },
    { text: 'Leduc', value: 'Leduc' },
    { text: 'Prince George', value: 'Prince George' },
    { text: 'Red Deer', value: 'Red Deer' },
    { text: 'Whitehorse', value: 'Whitehorse' },
    { text: 'Delta', value: 'Delta' }
];

const EmailSubscribeForm = ({ onSubmit, disabled, errorMsg }) => {
    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnBlur: true,
        validateOnChange: true,
        validateOnMount: true,
        enableReinitialize: true,
        onSubmit: (formData) => onSubmit({ ...formData })
    });

    const getErrorMsg = (name) => {
        return formik.touched[name] && formik.errors[name] ? (
            <div style={{ color: 'red' }}>{formik.errors[name]}</div>
        ) : null;
    };

    const getFormGroupClass = (fieldName, override) => {
        const defaultClassName = override || 'form-group';
        return formik.touched[fieldName] && formik.errors[fieldName] ? `${defaultClassName} invalid` : `${defaultClassName}`;
    };

    return (
        <div className='container my-4'>
            {errorMsg ? <p className='alert alert-danger'>{errorMsg}</p> : null}
            <form onSubmit={formik.handleSubmit}>
                <div className="form-row">
                    <div className={getFormGroupClass('firstName') + " col-12 col-md-6"}>
                        <input
                            className="form-control"
                            id="firstName"
                            name="firstName"
                            placeholder="First Name*"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.firstName}
                        />
                        {getErrorMsg('firstName')}
                    </div>

                    <div className={getFormGroupClass('lastName') + " col-12 col-md-6"}>
                        <input
                            className="form-control"
                            id="lastName"
                            name="lastName"
                            placeholder="Last Name*"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.lastName}
                        />
                        {getErrorMsg('lastName')}
                    </div>

                    <div className={getFormGroupClass('email') + " col-12"}>
                        <input
                            className="form-control"
                            id="email"
                            name="email"
                            placeholder="Email*"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                        />
                        {getErrorMsg('email')}
                    </div>

                    <div className={getFormGroupClass('location') + " col-12"}>
                        <select
                            className="form-control"
                            id="location"
                            name="location"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.location}
                        >
                            {locations.map(({ text, value }, index) => (
                                <option key={index} value={value}>
                                    {text}
                                </option>
                            ))}
                        </select>
                        {getErrorMsg('location')}
                    </div>

                    <div className='form-group'>
                        <div className='form-check'>
                            <input
                                type='checkbox'
                                className="form-check-input "
                                id="optIn"
                                name="optIn"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value='optIn'
                            />
                            <label className="form-check-label ml-4" htmlFor="optIn">
                                Yes, I consent to receive promotional emails from Fraserway RV. I understand that I can unsubscribe at any time.
                            </label>
                            {getErrorMsg('optIn')}
                        </div>
                    </div>
                </div>

                <button type="submit" disabled={disabled} className='btn btn-primary'>Submit</button>
            </form>
        </div>
    );
};

export default EmailSubscribeForm;
